/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetNetworkPingRequest = { host: string };

export const GetNetworkPingRequest$zodSchema: z.ZodType<GetNetworkPingRequest> =
  z.object({
    host: z.string().describe("你需要 Ping 的目标主机，可以是域名或IP地址。"),
  });

/**
 * 服务繁忙。当服务器 Ping 请求过多时，会触发限流。前端可直接展示 `message` 字段。
 *
 * @remarks
 *
 * ```json
 * {
 *     "code": "SERVICE_BUSY",
 *     "message": "Ping 服务正忙，请稍后再试。"
 * }
 * ```
 */
export type GetNetworkPingTooManyRequestsResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetNetworkPingTooManyRequestsResponseBody$zodSchema: z.ZodType<
  GetNetworkPingTooManyRequestsResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe(
  "服务繁忙。当服务器 Ping 请求过多时，会触发限流。前端可直接展示 `message` 字段。\n\n```json\n{\n    \"code\": \"SERVICE_BUSY\",\n    \"message\": \"Ping 服务正忙，请稍后再试。\"\n}\n```",
);

/**
 * 请求失败，参数无效或目标不可达。前端可直接展示 `message` 字段。
 *
 * @remarks
 *
 * **可能原因**:
 * - **无法解析主机**: `host` 参数是一个无效的域名或IP地址。
 *   ```json
 *   {
 *       "code": "INVALID_PARAMETER",
 *       "message": "无法解析主机 '无效的主机名'，请检查输入是否正确。"
 *   }
 *   ```
 * - **Ping 超时**: 目标主机无法访问或被防火墙拦截。
 *   ```json
 *   {
 *       "code": "INVALID_PARAMETER",
 *       "message": "对主机 '目标主机' 的 Ping 请求超时，目标可能不可达或防火墙已拦截。"
 *   }
 *   ```
 */
export type GetNetworkPingBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetNetworkPingBadRequestResponseBody$zodSchema: z.ZodType<
  GetNetworkPingBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe(
  "请求失败，参数无效或目标不可达。前端可直接展示 `message` 字段。\n\n**可能原因**:\n- **无法解析主机**: `host` 参数是一个无效的域名或IP地址。\n  ```json\n  {\n      \"code\": \"INVALID_PARAMETER\",\n      \"message\": \"无法解析主机 '无效的主机名'，请检查输入是否正确。\"\n  }\n  ```\n- **Ping 超时**: 目标主机无法访问或被防火墙拦截。\n  ```json\n  {\n      \"code\": \"INVALID_PARAMETER\",\n      \"message\": \"对主机 '目标主机' 的 Ping 请求超时，目标可能不可达或防火墙已拦截。\"\n  }\n  ```",
);

/**
 * Ping 操作成功！返回延迟统计数据。
 */
export type GetNetworkPingResponseBody = {
  avg?: number | undefined;
  host?: string | undefined;
  ip?: string | undefined;
  location?: string | undefined;
  max?: number | undefined;
  min?: number | undefined;
};

export const GetNetworkPingResponseBody$zodSchema: z.ZodType<
  GetNetworkPingResponseBody
> = z.object({
  avg: z.number().optional(),
  host: z.string().optional(),
  ip: z.string().optional(),
  location: z.string().optional(),
  max: z.number().optional(),
  min: z.number().optional(),
}).describe("Ping 操作成功！返回延迟统计数据。");

export type GetNetworkPingResponse =
  | GetNetworkPingResponseBody
  | GetNetworkPingBadRequestResponseBody
  | GetNetworkPingTooManyRequestsResponseBody;

export const GetNetworkPingResponse$zodSchema: z.ZodType<
  GetNetworkPingResponse
> = z.union([
  z.lazy(() => GetNetworkPingResponseBody$zodSchema),
  z.lazy(() => GetNetworkPingBadRequestResponseBody$zodSchema),
  z.lazy(() => GetNetworkPingTooManyRequestsResponseBody$zodSchema),
]);
